export const phoneRegex = /^(\+30|0030)?\d{10}$/;
export const passwordRegex = /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*\W).{8,}$/;
export const postalCodeRegex = /^[0-9]{5}$/;
export const afmRegex = /^\d{9}$/;
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
